import { useQuery } from '@northladder/services';

import { B2B_SERVICE_API } from '../b2bApiClient';
import { ISignUpPayload } from '../types';

/**
 * To track the cache key entry for signup data.
 */
const FETCH_COMPLETE_REGISTRATION_KEY = 'fetch-complete-registration-key';

/**
 * It fetches the signup data.
 */
export const useCompleteRegistrationQuery = (token: string) => {
  const { data, error, isError, isLoading, refetch } = useQuery<ISignUpPayload>(
    {
      queryKey: [FETCH_COMPLETE_REGISTRATION_KEY, token],
      queryFn: () => B2B_SERVICE_API.fetchEnterpriseDetails(token),
    }
  );

  return {
    data,
    error,
    isError,
    isLoading,
    refetch,
  };
};
